import type { FileMeta } from '../../../shared/transfer.js';
import type { FileSink, SinkKind } from './file-sink.js';
import { isWebKit, pickSinkKind } from './file-sink.js';
import { createFileSystemSink, hasSaveFilePicker, pickerWindow } from './file-system-sink.js';
import { createMemorySink } from './memory-sink.js';
import { createServiceWorkerSink } from './service-worker-sink.js';

export const detectSinkKind = (): SinkKind =>
  pickSinkKind({
    hasSaveFilePicker: hasSaveFilePicker(pickerWindow()),
    hasControllingWorker: 'serviceWorker' in navigator && navigator.serviceWorker.controller !== null,
    webkit: isWebKit(navigator.userAgent),
  });

/** Must be called from a user gesture: the picker and the download both require one. */
export const createSink = (kind: SinkKind, meta: FileMeta): Promise<FileSink> => {
  switch (kind) {
    case 'file-system-access':
      return createFileSystemSink(pickerWindow(), meta);
    case 'service-worker': {
      const worker = navigator.serviceWorker.controller;
      if (worker === null) {
        throw new Error('No service worker controls this page');
      }
      return createServiceWorkerSink(worker, meta);
    }
    case 'memory':
      return Promise.resolve(createMemorySink(meta));
  }
};
